import React from 'react'

const Attendance = () => {
  return (
    <div>
      <p>attendance</p>
    </div>
  )
}

export default Attendance
